"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmptySimpleObject = exports.pruneEmpty = exports.getChangedProps = void 0;
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const getChangedProps = (newObj, oldObj, excludedProps) => {
    if (!oldObj)
        return newObj;
    return Object.keys(newObj).reduce((acc, prop) => {
        const oldProp = oldObj[prop];
        const newProp = newObj[prop];
        if (!(excludedProps || []).includes(prop) && !(0, isEqual_1.default)(oldProp, newProp)) {
            acc[prop] = newObj[prop];
        }
        return acc;
    }, {});
};
exports.getChangedProps = getChangedProps;
/**
 * a function to remove all properties from an object that has null, empty string, or undefined values,
 * including its nested objects
 */
function pruneEmpty(data) {
    return Object.entries(data).reduce((acc, [key, value]) => {
        if (value == null || value === '')
            return acc;
        if (typeof value === 'object') {
            const newValue = pruneEmpty(value);
            if (Object.keys(newValue).length === 0)
                return acc;
            return Object.assign(Object.assign({}, acc), { [key]: newValue });
        }
        return Object.assign(Object.assign({}, acc), { [key]: value });
    }, {});
}
exports.pruneEmpty = pruneEmpty;
/**
 * a function to check if an object is empty
 * only check for simple object (array, set, map, date, regexp, weakmap, weakset, string, number, boolean all are objects
 * but won't be considered as simple object)
 */
function isEmptySimpleObject(obj) {
    if (typeof obj !== 'object' ||
        obj === null ||
        Array.isArray(obj) ||
        obj instanceof Set ||
        obj instanceof Map ||
        obj instanceof Date ||
        obj instanceof RegExp ||
        obj instanceof WeakMap ||
        obj instanceof WeakSet ||
        obj instanceof String ||
        obj instanceof Number ||
        obj instanceof Boolean) {
        return false;
    }
    return Object.keys(obj).length === 0;
}
exports.isEmptySimpleObject = isEmptySimpleObject;
